



















import { defineComponent } from '@vue/composition-api';
import defaultAvatar from '@tt4b/ttam-assets/src/images/creative/default-avatar.png';

const name = 'ttam-tiktok-identity-display';

export default defineComponent({
  name,
  props: {
    title: {
      type: String,
      default: '',
    },
    avatar: {
      type: String,
      default: defaultAvatar,
    },
    flexStyle: {
      type: String,
      default: 'row',
    },
    displayName: {
      type: String,
      default: '',
    },
    componentSize: {
      type: String,
      default: 'small',
    },
  },
  setup() {
    return {
      name,
      defaultAvatar,
    };
  },
});
